export * as isCertificate from './is-certificate'
